import JsonHelper from "./statisticsUtils";

/* eslint-disable camelcase */
export default class TreeSerializer {
  static build_directory_dto(tree_struct) { // , tree_name_10_chars) {
    console.log('LOADEDT#022');
    console.log('LOADEDT#023', tree_struct);
    const structureAxis = [
      {
        position: 'TABLE_FILTER',
        children: TreeSerializer.build_dto_subtree(tree_struct.pureFilter_graph),
      },
      {
        position: 'PRECONDITION',
        children: TreeSerializer.build_dto_subtree(tree_struct.precondition_graph),
      },
      {
        position: 'SUBTITLE',
        children: TreeSerializer.build_dto_subtree(tree_struct.headings_graph),
      },
      {
        position: 'SUBHEADING',
        children: TreeSerializer.build_dto_subtree(tree_struct.realHeadings_graph),
      },
      {
        position: 'COLUMN_STRUCTURE',
        children: TreeSerializer.build_dto_subtree(tree_struct.spalte1_graph),
      },
      {
        position: 'ROW_STRUCTURE',
        children: TreeSerializer.build_dto_subtree(tree_struct.zeilen_graph),
      },
    ];
    console.log('LOADEDT#024', structureAxis);
    const ret = {
      structureAxis,
    };
    console.log('LOADEDT#025', ret);
    return ret;
  }

  /** Call only from within build_directory_dto */
  static build_dto_subtree(tree_ary) {
    // return `null` indicates property `children` shall not be created in `build_dto_subtree_node`
    if (!tree_ary) { return []; }
    if (tree_ary.length === 0) { return []; }
    const tree_body = tree_ary.map((nodeItem) => {
      // node.id = -1;
      const node = nodeItem;
      const filterIds = node.filterIds;
      delete node.filterIds
      console.log('NODENAME#5', node);
      delete node.dontAddClassifying; // Merker 2650
      delete node.uniqueId;
      delete node.activeFilter;
      delete node.activeRule;
      delete node.showRules;
      delete node.text;
      delete node.title;
      delete node.code;
      delete node.expanded;
      delete node.inhalt;
      delete node.display;
      delete node.isAverageMedian;
      delete node.siblingsDTO; // richtig?
      node.type = 'VARIABLE';
      TreeSerializer.build_dto_subtree(node.children);
      if (node.filter) { // #TODO weitermachen
        node.selectionReference = TreeSerializer.build_value_selection(
          node.filter, node.variableType, node.name, node.id, node.langText, node.classificationKey, node.ruleName, node.ruleObject, node.hierarchyLevels, filterIds
        );
      }
      delete node.hierarchyLevels
      delete node.filter;
      delete node.langText;
      // delete node.ruleName; // 1715 s. Kommentar 22.08.23
      delete node.ruleObject; // 1715
      delete node.classificationKey; // 2166
      if(node.selectionReference) node.selectionName = node.selectionReference.name
      return node;
    });
    return tree_body;
  }

  /** Call only from within build_dto_subtree
       * @param {string} node_code a merkmal code
       * @param {string[]} node_selection an array of aupraegung codes
       * @param {T} child_dto a subtree generated by this library
       * @return {T} a subtree suitable as col_graph etc.
      */
  static build_dto_subtree_node(node_code, node_filter) { // }, child_dto) {
    const proto_json = {
      '@class': 'genesis.transfer.model.dto.display.StructureElementDTO',
      type: 'VARIABLE',
      name: node_code, // e.g. 'DINSG'
      // children: child_dto,
      // selectionReference: node_selection,
    };
    // if (child_dto) { proto_json['children'] = child_dto; }
    if (node_filter) { proto_json.selectionReference = null; }
    return proto_json;
  }

  static getNameKey() {
    return Math.random().toString().slice(2,12)
  }

  static build_value_selection(acode_ary, variableType, name, id, langText, classificationKeys, ruleName, ruleObject, hierarchyLevels, filterIds, acode_ary_index=0) {
    console.log('NODENAME#3', name, acode_ary, acode_ary_index);
    // für Ticket ADBHSSTAT-1238
    // id = 0; // FEHLER !!!
    let ret;
    if (variableType === 'TIME_IDENTIFYING') {
      ret = {
        '@class': 'genesis.transfer.model.gom.display.TimeSelection',
        name: `${name}-${TreeSerializer.getNameKey()}`,
        dateChoice: {
          '@class': 'genesis.transfer.model.gom.display.DateChoiceSelection',
          name: `${name}-${TreeSerializer.getNameKey()}`,
          repraesentation: 'YEAR',
          referenceObject: name,
          dateChoice: acode_ary,
        },
        referenceObject: name,
      };
    } else {
      if(ruleName) {
        ret = {
          '@class': 'genesis.transfer.model.gom.display.ValueSelection',
          // ADBHSSTAT-2030
          name: `${acode_ary[acode_ary_index][0].variableName}-${TreeSerializer.getNameKey()}`,
          referenceObject: acode_ary[acode_ary_index][0].variableName,
          rule: hierarchyLevels[acode_ary[acode_ary_index][0].variableName] || ruleName,
          // ADBHSSTAT-2030 end
          // ADBHSSTAT-1763 text to langText
          auspraegungen: acode_ary[acode_ary_index].map((acode, index) => {
            const text = (langText) ? langText[index] : '';
            const classificationKey = (classificationKeys) ? classificationKeys[index] : null;
            return {
              hierarchie: false,
              valueName: acode.name,
              valueReference: {
                '@class': 'genesis.transfer.model.dto.statistic.metadata.ValueAssociationDTO',
                attributeLength: {},
                federation: {
                  federationKey: null,
                  federations: [],
                },
                tmpLock: null,
                classificationKey,
                id: acode_ary[acode_ary_index][index].id,
                mark: ' ',
                ownerInfo: null,
                protection: 'UNDEF',
                variableCount: -1,
                level: -1,
                levelTotal: -1,
                cutPosition: null,
                parent: null,
                variableIdent: -1,
                variableName: acode.variableName,
                variableValidFrom: null,
                variableValidTo: null,
                associationProtection: 'UNDEF',
                mark2: ' ',
                positionNr: -1,
                valueId: -1,
                periods: [],
                variableReference: null,
                description: null,
                explanation: null,
                shortDescription: {
                  '@type': 'MehrsprachigerText',
                  langText: [
                    {
                      '@type': 'Text',
                      sprachKennzeichen: 'de',
                      text,
                      approved: false,
                      format: 'UNDEF',
                    },
                  ],
                },
                longtext: null,
                definition: null,
                notes: null,
                label: null,
                federationName: null,
                name: acode.name,
                variables: [],
                variableTempLock: false,
                modifiedTime: '08.02.2023 07:53:06',
                createdTime: '08.02.2023 07:53:06',
                extractedTime: '08.02.2023 07:53:06',
                modifiedDatabaseTime: null,
              },
            };
          }),
          nextSelection: acode_ary[acode_ary_index +1] ? TreeSerializer.build_value_selection(acode_ary, variableType, name, id, langText, classificationKeys, ruleName, ruleObject, hierarchyLevels, filterIds, acode_ary_index + 1) : null
        };   
      }
     else {
      ret = {
        '@class': 'genesis.transfer.model.gom.display.ValueSelection',
        // ADBHSSTAT-2030
        name: `${name}-${TreeSerializer.getNameKey()}`, // id${(new Date()).getTime()}`,
        referenceObject: name,
        // ADBHSSTAT-2030 end
        // ADBHSSTAT-1763 text to langText
        auspraegungen: acode_ary.map((acode, index) => {
          const text = (langText) ? langText[index] : '';
          const classificationKey = (classificationKeys) ? classificationKeys[index] : null;
          return {
            hierarchie: false,
            valueName: acode,
            valueReference: {
              '@class': 'genesis.transfer.model.dto.statistic.metadata.ValueAssociationDTO',
              attributeLength: {},
              federation: {
                federationKey: null,
                federations: [],
              },
              tmpLock: null,
              classificationKey,
              id: filterIds?.[index],
              mark: ' ',
              ownerInfo: null,
              protection: 'UNDEF',
              variableCount: -1,
              level: -1,
              levelTotal: -1,
              cutPosition: null,
              parent: null,
              variableIdent: -1,
              variableName: null,
              variableValidFrom: null,
              variableValidTo: null,
              associationProtection: 'UNDEF',
              mark2: ' ',
              positionNr: -1,
              valueId: -1,
              periods: [],
              variableReference: null,
              description: null,
              explanation: null,
              shortDescription: {
                '@type': 'MehrsprachigerText',
                langText: [
                  {
                    '@type': 'Text',
                    sprachKennzeichen: 'de',
                    text,
                    approved: false,
                    format: 'UNDEF',
                  },
                ],
              },
              longtext: null,
              definition: null,
              notes: null,
              label: null,
              federationName: null,
              name: acode,
              variables: [],
              variableTempLock: false,
              modifiedTime: '08.02.2023 07:53:06',
              createdTime: '08.02.2023 07:53:06',
              extractedTime: '08.02.2023 07:53:06',
              modifiedDatabaseTime: null,
            },
          };
        }),
      };
     }
    }
    console.log('RET#1', ret);
    return ret;
  }

  static build_value_selection_prod(acode_ary, variableType, name) {
    let ret;
    if (variableType === 'TIME_IDENTIFYING') {
      ret = {
        '@class': 'genesis.transfer.model.gom.display.TimeSelection',
        name: `${name}-${TreeSerializer.getUniqueNameKey()}`,
        dateChoice: {
          '@class': 'genesis.transfer.model.gom.display.DateChoiceSelection',
          name: `${name}-${TreeSerializer.getUniqueNameKey()}`,
          repraesentation: 'YEAR',
          referenceObject: name,
          dateChoice: acode_ary,
        },
        referenceObject: name,
      };
    } else {
      ret = {
        '@class': 'genesis.transfer.model.gom.display.ValueSelection',
        auspraegungen: acode_ary.map((acode) => ({
          hierarchie: false,
          valueName: acode,
        })),
      };
    }
    return ret;
  }
}
